import { useMemo } from 'react';
import { useProfile } from '../components/state/hooks';
import {
  t as translate,
  yearLabel,
  isUsCountry,
  isNzCountry,
  localizeText,
} from '../utils/lexicon';

// Country-keyed lexicon bound to the signed-in user's profile. Until the
// profile resolves, country is undefined and t() is the identity — an AU
// user can never see a US-label flash (a US user briefly seeing AU labels
// on first paint is the acceptable direction). Onboarding surfaces that
// know the country before a profile exists pass it to t() explicitly.
export const useLexicon = () => {
  const { data: profile } = useProfile();
  const country = profile?.country;
  return useMemo(
    () => ({
      country,
      isUS: isUsCountry(country),
      isNZ: isNzCountry(country),
      t: (text) => translate(text, country),
      lt: (text) => localizeText(text, country),
      yearLabel: (year) => yearLabel(year, country),
    }),
    [country]
  );
};
